import { useRuntimeConfig, useAppConfig } from '#app'
import type { SupportedCountry, PublicCountryConfig } from '~/index'

export const useCountryConfig = (forcedCountry?: SupportedCountry) => {
  const { country, environment } = useRuntimeConfig().public
  const { baseURL } = useRuntimeConfig().app
  const { countryConfig } = useAppConfig()
  const config = countryConfig[forcedCountry ?? country] ?? countryConfig[country]
  return {
    ...config,
    ...(config.envOverwrites?.[environment] ?? {}),
    baseURL: (forcedCountry && forcedCountry !== country) ? `/${forcedCountry}` : baseURL,
    countryCode: forcedCountry ?? country,
  } as Omit<PublicCountryConfig, 'envOverwrites'> & { baseURL: string, countryCode: SupportedCountry }
}
